import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { ajaxPut } from '../../ajax'
import Alert from './alert'

const ResetPasswordForm = props => {
  const [isLoading, setIsLoading] = useState(false)
  const [alert, setAlert] = useState(null)
  const [alertClass, setAlertClass] = useState('')

  const { register, handleSubmit, watch, formState: { errors }  } = useForm({})

  const showAlert = (text) => {
    setAlert(text)
    setAlertClass('open-alert')
  }
  
  const onSubmit = (data) => {
    setIsLoading(true)

    const formData = {
      authenticity_token: props.authenticity_token,
      user: {
        reset_password_token: props.reset_password_token,
        password: data.password,
        password_confirmation: data.password_confirmation
      }
    }

    ajaxPut('/users/password', formData)
    .then(response => response.json())
    .then(json => {
      setIsLoading(false)
      if (json.error) {
        showAlert(json.error)
      } else {
        window.location.href = '/'
      }
    })
  }

  return (
    <div className='landing-wrapper'>
      <div className='form-container'>
        <img className='logo' src='/images/new-logo.svg'/>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='input-container'>
            <label>Password:</label>
            <input
              className={errors.password ? 'error' : ''}
              type='password'
              {...register('password', { required: 'This field is required' })}
              placeholder='New password'
            />
            {errors.password && <div className='error-container'>{errors.password.message}</div>}
          </div>
          <div className='input-container'>
            <label>Password confirmation:</label>
            <input
              className={errors.password_confirmation ? 'error' : ''}
              type='password'
              {...register('password_confirmation', {
                required: 'This field is required',
                validate: val => { if (watch('password') != val) { return 'Passwords do not match' } },
              })}
              placeholder='Password confirmation'
            />
            {errors.password_confirmation && <div className='error-container'>{errors.password_confirmation.message}</div>}
          </div>
          <button className='submit-button' type='submit'>
            {isLoading ? <div className='connection-loader'/> : 'Submit'}
          </button>
        </form>
        <a href='/'>Back to Login</a>
      </div>
      { alert &&
        <Alert
          className={alertClass}
          text={alert}
          onHide={() => setAlertClass('close-alert')}
          onRemove={() => setAlert(null)}
        />
      }
    </div>
  )
}

export default ResetPasswordForm
